
import { Vue, Component, Watch } from 'vue-property-decorator'
import {
    TotalDataDTO, DataDTO, getGoodsSaleTotal, exportAreaGoods, statisticByGoodsName,
    statisticByGoodsCategory, statisticByGoodsBrand, statisticByGoodsNameTop10,
    statisticByGoodsCategoryTop10, statisticByGoodsBrandTop10
} from '@/api/dataReport'
import dayjs from 'dayjs'
import { moneyFormat, handlePercentage, handleAmount } from '@/utils/util'
import { getFileName } from '@/utils/fileUtil'
import { exportFileWithData } from '@/utils/h5ToApp'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import TypeProp from '@/views/dataReport/template/TypeProp.vue'
import { Chart } from '@antv/g2'
import LineListCard from '@/views/dataReport/template/lineListCard.vue'
import { getGoodsCategoryList, GoodsCategoryListDto } from '@/api/commodity'
import CategoryTree from '@/views/dataReport/template/categoryTree.vue'
import { Getter } from 'vuex-class'
import { colors } from './chartColors'

@Component({
    components: {CategoryTree, DataSelect, TypeProp, LineListCard}
})
export default class SaleReport extends Vue {
    @Getter companyId!: string
    moneyFormat = moneyFormat
    handleAmount = handleAmount
    handlePercentage = handlePercentage
    readonly format = 'YYYY-MM-DD'
    colors = colors
    finished = false
    loading = false
    refreshing = false

    legendMore = false // chart图标是否查看更多

    queryParams = {
        type: 1,
        startDate: dayjs().format(this.format),
        endDate: dayjs().format(this.format),
        orderFieldName: 1,//排序字段    1：订货商品数量  2：订货金额  3：退货商品数量  4：退货金额
        pageIndex: 1,
        pageSize: 10,
        statisticalSection: 'area',// 统计区间(地区 ==>area or部门==>dept)
        orderType: 'desc', // asc:升序, desc:降序
        hierarchyId: '', // 商品分类层级号
    }

    sortType = 1 // 排序方式
    customerType = 1 // 数据请求类型
    categoryName = '全部分类' //商品分类中文展示

    showSortPop = false // 排序方式弹框显示与否
    showTypePop = false // 数据请求类型弹框显示与否
    showCategory = false // 商品分类选择弹框显示与否


    sortTypeList = [
        {
            text: '订货数量排行',
            value: 1
        },
        {
            text: '订货金额排行',
            value: 2
        },
        {
            text: '退货数量排行',
            value: 3
        },
        {
            text: '退货金额排行',
            value: 4
        },
    ] // 排序方式列表

    customerTypeList = [
        {
            text: '按商品名称统计',
            value: 1
        },
        {
            text: '按商品分类统计',
            value: 2
        },
        {
            text: '按商品品牌统计',
            value: 3
        },
    ] // 数据请求方式列表

    totalDataType = [
        {
            key: 'orderSum',
            title: '订货单'
        },
        {
            key: 'returnOrderSum',
            title: '退货单'
        },
        {
            key: 'orderMoney',
            title: '订货金额',
            type: 'money'
        },
        {
            key: 'returnMoney',
            title: '获批退款金额',
            type: 'money'
        },
        {
            key: 'orderCount',
            title: '订货数量'
        },
        {
            key: 'returnOrderCount',
            title: '退货数量'
        },
        {
            key: 'returnMoneySum',
            title: '退货金额',
            type: 'money'
        },
        {
            key: 'differenceMoney',
            title: '合计总金额',
            type: 'money'
        }
    ] //总数量统计字段类型

    totalData: TotalDataDTO | any = {}

    listType = [
        {
            text: '订货单',
            key: 'orderCount',
        },
        {
            text: '订货金额',
            key: 'receiveMoneyCount',
            type: 'money'
        },
        {
            text: '订货数量',
            key: 'receiveCount',
        },
        {
            text: '退货数量',
            key: 'returnCount'
        },
        {
            text: '退货单',
            key: 'returnOrderCount',
        },
        {
            text: '退货金额',
            key: 'returnMoneyCount',
            type: 'money'
        },
    ]

    chartData: DataDTO[] = []
    chart: Chart | null = null
    list: DataDTO[] = []

    categoryList: GoodsCategoryListDto[] | any = [{
        categoryName: '全部分类',
        hierarchyId: '',
        children: []
    }]


    get topLeft () {
        let key = 'goodsName'
        switch (this.queryParams.type) {
            case 1:
                key = 'goodsName'
                break
            case 2:
                key = 'categoryName'
                break
            case 3:
                key = 'brandName'
                break
        }
        return key
    }

    created () {
        this.load()
        this.getGoodsCategoryList()
    }

    mounted () {
        this.initChart()
    }

    load () {
        this.queryParams.pageIndex = 1
        this.list = []
        this.finished = false
        this.getGoodsSaleTotal()
        this.getList()
    }

    get customerTypeText () {
        let text = '商品名称'
        switch (this.queryParams.type + '') {
            case '1':
                text = '商品名称'
                break
            case '2':
                text = '商品分类'
                break
            case '3':
                text = '商品品牌'
                break
            default:
                text = '商品名称'
                break
        }
        return text
    }

    get sortTypeText () {
        let text = '订货数量'
        switch (this.queryParams.orderFieldName + '') {
            case '1':
                text = '订货数量'
                break
            case '2':
                text = '订货金额'
                break
            case '3':
                text = '退货数量'
                break
            case '4':
                text = '退货金额'
                break
            default:
                text = '订货数量'
                break
        }
        return text
    }

    /**
     * 下拉刷新
     * */
    onRefresh () {
        this.refreshing = true
        this.load()
    }


    /**
     * 获取头部总数量统计数据
     */
    getGoodsSaleTotal () {
        getGoodsSaleTotal({
            startTime: this.queryParams.startDate,
            endTime: this.queryParams.endDate
        }).then(res => {
            this.totalData = res.data[0]
        })
    }


    // 饼图配置
    initChart () {
        const data: any = [
            {name: '', receiveCount: 0,random:''}
        ]
        // const e = document.createEvent('Event')
        // e.initEvent('resize', true, true)
        // window.dispatchEvent(e)

        const chart = new Chart({
            container: 'order-chart-container',
            autoFit: true,
            height: 280
        })

        chart.legend(false)

        chart.coordinate('theta', {
            radius: 0.6,
            innerRadius: 0.55
        })

        chart.data(data)

        chart.tooltip({
            showTitle: false,
            showMarkers: false
        })
        chart
            .interval()
            .position('percentage')
            .color('random', this.colors)
            .label('percentage', (val) => {
                let isLabel = val > 0.2
                if (isLabel) {
                    return {
                        content: (data) => {
                            return `${data.name.length > 5 ? data.name.slice(0, 5) + ' ...' : data.name}:\n ${handlePercentage(data.percentage)}`
                        },
                        style: {
                            fill: '#313131',
                        },
                        layout: {type: 'pie-spider'},
                    }
                }
            })
            .tooltip('name*compareValue', (name, compareValue) => {
                return {
                    name: name,
                    value: compareValue,
                }
            })
            .adjust('stack')


        chart.interaction('element-active')
        chart.render()
        this.chart = chart
    }

    getGoodsCategoryList () {
        getGoodsCategoryList({isPage: false}).then(res => {
            this.categoryList[0].children = res.data || []
        })
    }

    getList () {
        this.loading = true
        // 表格
        const requests = [statisticByGoodsName, statisticByGoodsCategory, statisticByGoodsBrand]
        const requestTop10 = [statisticByGoodsNameTop10, statisticByGoodsCategoryTop10, statisticByGoodsBrandTop10]
        requests[this.queryParams.type - 1]({
            ...this.queryParams
        }).then(res => {
            this.list = this.list.concat(res.data.records)
            if (this.list.length >= res.data.totalRecords) {
                this.finished = true
            }
            this.queryParams.pageIndex++
        }).finally(() => {
            this.loading = false
            this.refreshing = false
        })

        // 图形数据
        requestTop10[this.queryParams.type - 1]({
            ...this.queryParams
        }).then(res => {
            this.chartData = res.data
            this.chartData.map((item,index) => {
              item.random = item.name + index
            })
            if (this.chartData.length > 0) {
                this.$nextTick(() => {
                    this.chart!.data(this.chartData)
                    this.chart!.render()
                })
            }
        })
    }

    /**
     * 头部总时间段改变
     * @param value
     */
    handleDataChange (value: Array<string>) {
        this.queryParams.startDate = value[0]
        this.queryParams.endDate = value[1]
        this.load()
    }

    /**
     * 数据请求类型改变
     * @param data
     */
    handleCustomerTypeChange (data: { text: string, value: number }) {
        this.showTypePop = false
        this.$set(this.queryParams, 'type', data.value)
        this.load()
    }


    handleSortTypeChange (data: { text: string, value: number }) {
        this.showSortPop = false
        this.queryParams.orderFieldName = data.value
        this.load()
    }

    // 商品分类选择改变
    handleCategoryChange (data: { text: string, value: string }) {
        console.log(data.text)
        this.showCategory = false
        this.categoryName = data.text
        this.queryParams.hierarchyId = data.value
        this.load()
    }

    /**
     * 导出
     */
    handleExport () {
        let param = {
            ...this.queryParams,
            companyId: this.companyId,
            startTime: this.queryParams.startDate,
            endTime: this.queryParams.endDate
        }
        exportFileWithData({
            method: 'post',
            portUrl: '/cykjreport/RegionalByCommodity/exportAreaGoods',
            params: JSON.stringify(param)
        })
    }
}
